import { ERROR_MESSAGES } from 'constants/errorMessages'
import { PATH_NAMES } from 'constants/pathNames'

import { Form } from 'antd'
import { getOtpErrorMsg } from 'features/authentication/helpers'
import { loadingActions } from 'features/globalLoading'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { openNotification } from 'utils/notification'

import { OTP_KEY, OTP_TIME } from '../constants'
import { authenticationServices } from '../services'
import { authActions } from '../stores'
import { IAuthState } from '../types/authStoreTypes'

const useLoginForm = () => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const phoneNumber = Form.useWatch('phoneNumber', form)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const prevPath = searchParams.get('prevPath')

  const { mutate: onSubmit } = useMutation(authenticationServices.login, {
    onMutate: () => {
      dispatch(loadingActions.showLoading())
    },
    onSettled: () => {
      dispatch(loadingActions.hideLoading())
    },
    onSuccess: ({ data: userInfos }) => {
      dispatch(authActions.loginPhoneNumber({ ...userInfos, phone: phoneNumber } as IAuthState))
      localStorage.setItem(OTP_KEY, OTP_TIME.EXPRIED.toString())
      navigate({
        pathname: PATH_NAMES.OTP_PATH,
        search: prevPath ? `prevPath=${prevPath}` : undefined,
      })
    },
    onError: (error: any) => {
      const errorMsg = getOtpErrorMsg(error)

      openNotification({
        type: 'error',
        description: errorMsg || ERROR_MESSAGES.ERR_SYS,
      })
    },
  })

  return {
    form,
    onSubmit,
    phoneNumber,
  }
}

export { useLoginForm }
